import { ReactNode } from 'react'

type Props = {
  onClickHandler: () => void
  disabled: boolean
  icon: ReactNode
}

export default function IconButton({ onClickHandler, disabled, icon }: Readonly<Props>) {
  return (
    <button
      onClick={onClickHandler}
      className="hover:cursor-pointer hover:text-white disabled:text-zinc-700 disabled:hover:cursor-default disabled:hover:text-zinc-700"
      disabled={disabled}
    >
      {icon}
    </button>
  )
}
